import { render } from "./StockItemsView.vue?vue&type=template&id=c2b83576"
import script from "./StockItemsView.vue?vue&type=script&lang=js"
export * from "./StockItemsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__